import { create } from "zustand";

interface LogoutState {
    open: boolean;
    handleLogout: (value: boolean) => void;
}

export const useLogoutStore = create<LogoutState>()((set) => ({
    open: false,
    handleLogout: (value: boolean) => set(() => ({ open: value })),
}));
